<template>
  <popup-modal ref="popup">
    <div>
      <DialogCloseButton :close-method="closeDialog" />

      <div>
        <h2 class="font-weight-bold">
          {{ $t('FILE_STEP_TRANSPORT_MODALITY.MODAL.BATTERY.TITLE') }}
        </h2>
        <div class="my-10" style="text-align: start">
          <p class="text-pre-line">
            {{ $t('FILE_STEP_TRANSPORT_MODALITY.MODAL.BATTERY.MESSAGE') }}
          </p>
        </div>
        <v-row no-gutters class="mb-10">
          <v-col cols="12" md="4" class="input-content">
            <v-col class="pa-0">
              <p data-custom="true" class="pb-5">
                {{ $t('FILE_STEP_TRANSPORT_MODALITY.MODAL.BATTERY.TEXT_INPUT.VOLTAGE') }}
              </p>
              <v-autocomplete
                v-model.trim="voltage"
                :placeholder="$t('FILE_STEP_TRANSPORT_MODALITY.MODAL.BATTERY.PLACEHOLDER.VOLTAGE')"
                :items="voltageList"
                :no-data-text="$t('COMMON.NO_DATA')"
                clearable
                hide-details
                item-title="name"
                item-value="value"
                class="pb-5"
              />
            </v-col>
            <v-col class="pa-0">
              <p data-custom="true" class="pb-5">
                {{ $t('FILE_STEP_TRANSPORT_MODALITY.MODAL.BATTERY.TEXT_INPUT.AMPERAGE') }}
              </p>
              <v-autocomplete
                v-model.trim="amperage"
                :placeholder="$t('FILE_STEP_TRANSPORT_MODALITY.MODAL.BATTERY.PLACEHOLDER.AMPERAGE')"
                :items="amperageList"
                :no-data-text="$t('COMMON.NO_DATA')"
                clearable
                hide-details
                item-title="name"
                item-value="value"
              />
            </v-col>
          </v-col>

          <v-col cols="12" md="1" class="my-4" />

          <v-col
            cols="12"
            md="7"
            class="box-content"
            :class="{
              'box-content-red': wattHour >= 100 && wattHour && !expressCheckbox,
              'box-content-green': (wattHour < 100 && wattHour) || (wattHour && expressCheckbox)
            }"
          >
            <p class="watt-content">
              {{ wattHour ? wattHour + 'Wh' : '-' }}
            </p>
            <div v-if="wattHour && wattHour >= 100 && !expressCheckbox" class="express-content">
              <p class="express-text">
                {{ $t('FILE_STEP_TRANSPORT_MODALITY.MODAL.BATTERY.EXPRESS.NO') }}
              </p>
            </div>
            <div
              v-if="(wattHour && wattHour < 100) || (wattHour && expressCheckbox)"
              class="express-content"
            >
              <p class="express-text">
                {{ $t('FILE_STEP_TRANSPORT_MODALITY.MODAL.BATTERY.EXPRESS.YES') }}
              </p>
            </div>
          </v-col>
        </v-row>

        <div class="d-flex justify-space-between mb-10" v-if="wattHour >= 100">
          <v-col md="1" class="pa-0">
            <v-checkbox hide-details v-model="expressCheckbox" class="checkbox" />
          </v-col>
          <v-col class="checkbox pb-0 pt-4 pl-0">
            <p>{{ $t('FILE_STEP_TRANSPORT_MODALITY.MODAL.BATTERY.TEXT_INPUT.CHECKBOX') }}</p>
          </v-col>
        </div>

        <div class="d-flex justify-center">
          <v-btn
            :disabled="!wattHour"
            class="boom-button modal-btn"
            variant="outlined"
            @click="_confirm"
          >
            {{ $t('COMMON.BUTTON.SAVE') }}
          </v-btn>
        </div>
      </div>
    </div>
  </popup-modal>
</template>

<script>
import PopupModal from '../PopupModal.vue'
import DialogCloseButton from '@/components/modal/DialogCloseButton.vue'

export default {
  name: 'BatteryModal',
  components: { DialogCloseButton, PopupModal },
  data: () => ({
    voltage: null,
    amperage: null,
    wattHour: null,
    expressCheckbox: false,
    voltageList: [
      { value: 3, name: '3V' },
      { value: 4, name: '4V' },
      { value: 7, name: '7V' },
      { value: 9, name: '9V' },
      { value: 10, name: '10V' },
      { value: 12, name: '12V' },
      { value: 14, name: '14V' },
      { value: 18, name: '18V' },
      { value: 24, name: '24V' },
      { value: 28, name: '28V' },
      { value: 36, name: '36V' },
      { value: 40, name: '40V' },
      { value: 54, name: '54V' }
    ],
    amperageList: [
      { value: 1, name: '1A' },
      { value: 2, name: '2A' },
      { value: 3, name: '3A' },
      { value: 4, name: '4A' },
      { value: 5, name: '5A' },
      { value: 5.5, name: '5.5A' },
      { value: 6, name: '6A' },
      { value: 8, name: '8A' },
      { value: 9, name: '9A' },
      { value: 12, name: '12A' }
    ],
    message: undefined,
    resolvePromise: undefined,
    rejectPromise: undefined
  }),
  watch: {
    voltage() {
      this.getWattHour()
    },
    amperage() {
      this.getWattHour()
    }
  },
  methods: {
    show(opts = {}) {
      this.message = opts.message
      this.transporter_power_max = opts.transporter_power_max

      this.$refs.popup.open()
      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve
        this.rejectPromise = reject
      })
    },
    _confirm() {
      this.$refs.popup.close()
      this.resolvePromise({
        confirmed: true,
        wattHour: this.wattHour,
        amperage: this.amperage,
        voltage: this.voltage,
        expressCheckbox: this.expressCheckbox
      })
      this.wattHour = null
      this.voltage = null
      this.amperage = null
      this.expressCheckbox = false
    },
    closeDialog() {
      this.wattHour = null
      this.voltage = null
      this.amperage = null
      this.expressCheckbox = false
      this.$refs.popup.close()
      this.resolvePromise({
        confirmed: false
      })
    },
    getWattHour() {
      if (this.voltage !== null && this.amperage !== null) {
        this.wattHour = this.voltage * this.amperage
      } else {
        this.wattHour = null
        this.expressCheckbox = false
      }
    }
  }
}
</script>
<style scoped>
:deep(.v-selection-control__input .v-icon) {
  color: #559a1b;
  opacity: unset;
}

:deep(.v-selection-control-group--inline) {
  margin: auto;
}

:deep(.logo-selector .v-field.v-field--appended) {
  justify-content: center !important;
  align-content: center;
}

:deep(.v-selection-control--inline .v-label) {
  opacity: unset;
}

.modal-btn {
  display: flex;
  width: 220px;
  padding: 11px 20px;
  justify-content: center;
  align-items: center;
  gap: 15px;
}

.box-content {
  text-align: center;
  border: 1px solid #dadada;
  display: flex;
  padding: 20px !important;
  flex-direction: column;
  justify-content: space-around;
}

.box-content-red {
  border-color: #ff5c5c;
}

.box-content-green {
  border-color: #86c94e;
}

.input-content {
  text-align: left;
}

.watt-content {
  margin: 0 15px 15px;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.express-content {
  background: #fafafa;
  border-radius: 20px;
  box-shadow: 6px 6px 12px 0 rgba(218, 218, 218, 0.4);
}

.express-text {
  padding: 10px 20px;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.checkbox {
  white-space: pre-line;
}
</style>
